import { IoMdClose } from 'react-icons/io';
import Text from '../text/Text';
import styles from './PopUp.module.css';
import { useAppContext } from 'src/app/state';

type PopUpProps = {
  isOpened: boolean;
  onClose: () => void;
};

const PopUp = ({ isOpened, onClose }: PopUpProps) => {
  const {
    state: { PopUpContent, PopUpFooter, popUpHeader },
  } = useAppContext();
  const Content = PopUpContent ? PopUpContent : () => <></>;
  const Footer = PopUpFooter ? PopUpFooter : () => <></>;

  return (
    <div
      className={`${styles['pop-up-wrapper']} ${isOpened ? styles.visible : styles.hidden}`}
    >
      <div
        className={`${styles['pop-up']} ${isOpened ? styles['pop-up-visible'] : styles['pop-up-hidden']}`}
      >
        <div className={styles['pop-up-header']}>
          <IoMdClose size={20} onClick={onClose} className='cursor-pointer' />
          {Boolean(popUpHeader) && (
            <Text tag='div' centered style={{ flex: 2 }}>
              {popUpHeader}
            </Text>
          )}
        </div>
        {Boolean(PopUpContent) && (
          <div className={styles['pop-up-body']}>
            <Content />
          </div>
        )}
        {Boolean(PopUpFooter) && (
          <div className={styles['pop-up-footer']}>
            <Footer />
          </div>
        )}
      </div>
    </div>
  );
};

export default PopUp;
